var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "600"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-eye")]), _vm._v(" Visualizar Disciplina ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-row', {
    staticClass: "justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.content.nome,
      "label": "Nome da Disciplina",
      "readonly": "",
      "outlined": "",
      "dense": ""
    }
  }), _c('v-text-field', {
    attrs: {
      "value": _vm.content.tipoDisciplina.tipoDisciplina,
      "label": "Tipo de Disciplina",
      "readonly": "",
      "outlined": "",
      "dense": ""
    }
  }), _c('v-textarea', {
    attrs: {
      "value": _vm.content.descricao,
      "label": "Descrição",
      "counter": "500",
      "readonly": "",
      "outlined": "",
      "dense": "",
      "rows": "6"
    }
  }), _c('v-textarea', {
    attrs: {
      "value": _vm.content.ementa,
      "label": "Ementa",
      "counter": "1000",
      "readonly": "",
      "outlined": "",
      "dense": "",
      "rows": "6"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "btn-group text-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  }, [_vm._v(" Fechar ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }